/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportConnectionTagsSmsDefinition } from '../fn/sms-connection/export-connection-tags-sms-definition';
import { ExportConnectionTagsSmsDefinition$Params } from '../fn/sms-connection/export-connection-tags-sms-definition';
import { importConfigurationSmsTagsDefinition } from '../fn/sms-connection/import-configuration-sms-tags-definition';
import { ImportConfigurationSmsTagsDefinition$Params } from '../fn/sms-connection/import-configuration-sms-tags-definition';


/**
 * All about the sms connections
 */
@Injectable({ providedIn: 'root' })
export class SmsConnectionService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exportConnectionTagsSmsDefinition()` */
  static readonly ExportConnectionTagsSmsDefinitionPath = '/stations/{uid}/sms/configuration/{smsUid}/export';

  /**
   * Export the SMS tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid smsUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportConnectionTagsSmsDefinition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsSmsDefinition$Response(params: ExportConnectionTagsSmsDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportConnectionTagsSmsDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the SMS tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid smsUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportConnectionTagsSmsDefinition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsSmsDefinition(params: ExportConnectionTagsSmsDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportConnectionTagsSmsDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importConfigurationSmsTagsDefinition()` */
  static readonly ImportConfigurationSmsTagsDefinitionPath = '/stations/{uid}/sms/configuration/{smsUid}/import';

  /**
   * Import the SMS tags definitions for a connection.
   *
   * Allows to import the SMS tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importConfigurationSmsTagsDefinition()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConfigurationSmsTagsDefinition$Response(params: ImportConfigurationSmsTagsDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importConfigurationSmsTagsDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the SMS tags definitions for a connection.
   *
   * Allows to import the SMS tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importConfigurationSmsTagsDefinition$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConfigurationSmsTagsDefinition(params: ImportConfigurationSmsTagsDefinition$Params, context?: HttpContext): Observable<void> {
    return this.importConfigurationSmsTagsDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
